import { connect } from "react-redux";
import ProductPrice from "../../../components/ProductTile/ProductPrice";
import { getThreeLineLayout } from "../../../state/modules/layout/selectors";

const mapStateToProps = state => ({
  shouldUseThreeLineLayout: getThreeLineLayout(state)
});

export default connect(mapStateToProps)(ProductPrice);
